var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoldings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0603 10.9713H12.5151C12.2727 10.9713 12.0752 11.1689 12.0752 11.4112C12.0752 11.5346 12.1276 11.6457 12.2094 11.726L16.1141 15.6306C16.1943 15.7171 16.3102 15.7711 16.4368 15.7711C16.5895 15.7711 16.7237 15.6939 16.8025 15.5766C17.7625 14.4623 18.3798 13.0471 18.491 11.4898C18.4971 11.4636 18.5002 11.4374 18.5002 11.4111C18.5003 11.1689 18.3042 10.9713 18.0603 10.9713Z",
    fill: "url(#paint0_linear_64_16620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8407 2.99988C10.5983 3.00136 10.4023 3.19743 10.4023 3.43972V9.60234C10.4023 9.84622 10.5983 10.0438 10.8407 10.0438H17.0049C17.2472 10.0438 17.4447 9.84622 17.4447 9.60234C17.227 6.05578 14.3888 3.21753 10.8407 2.99988Z",
    fill: "url(#paint1_linear_64_16620)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.228 15.2711L9.68128 10.7244C9.60414 10.6457 9.55786 10.5361 9.55786 10.4173L9.55623 3.99532C9.55623 3.75303 9.36026 3.55701 9.11792 3.55701C5.42468 3.78236 2.5 6.85051 2.5 10.5994C2.5 14.4964 5.65932 17.6572 9.55623 17.6572C11.3342 17.6572 12.9578 16.9997 14.1987 15.9147C14.2944 15.8344 14.3546 15.7141 14.3546 15.5798C14.3546 15.4609 14.3067 15.3513 14.228 15.2711Z",
    fill: "url(#paint2_linear_64_16620)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_64_16620",
    x1: 15.2877,
    y1: 10.9713,
    x2: 15.2877,
    y2: 15.7711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6857D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4530B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_64_16620",
    x1: 13.9235,
    y1: 2.99988,
    x2: 13.9235,
    y2: 10.0438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6857D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4530B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_64_16620",
    x1: 8.42729,
    y1: 3.55701,
    x2: 8.42729,
    y2: 17.6572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6857D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4530B3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoldings);
export default __webpack_public_path__ + "static/media/holdings.e9ed4c7235c0ea495a47ed907dade2ac.svg";
export { ForwardRef as ReactComponent };